define('recently_viewed_row.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('recently_viewed_row', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<ul class=\"recently-viewed-row-cell\" data-type=\"carousel-items\"><div data-type=\"backbone.collection.view.cells\"></div></ul>  ";
},"useData":true}, 'extensions/SC/Posh/3.5.5/', 'extensions/SC/Posh/3.5.5/', Handlebars);
});